<template>
<div class="chapter">
<div class="inner_page">
<div id="OldFlames_epub-7.html" xml:lang="en-US">
<div class="story">
<p class="CT-new-page"><span class="Section-Symbol char-style-override-19">A</span><span class="char-style-override-19">pril 1956</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OldFlames_epub7.vue?8ecde078